import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "utils";
import Device from "@/utils/device";
import StepForwardLink from "../step-forward/StepForwardLink";
import { CXL, H2 } from "@/components/Typography";
import Image from "next/image";

const partners = [
  {
    src: "/images/step-forward-2025/logo-pandora.png",
    alt: "logo for pandora",
  },
  {
    src: "/images/step-forward-2025/logo-british-business-bank.png",
    alt: "logo for british business bank",
  },
  {
    src: "/images/step-forward-2025/logo-etoro.png",
    alt: "logo for etoro",
  },
  {
    src: "/images/step-forward-2025/logo-tissot.png",
    alt: "logo for tissot",
  },
  {
    src: "/images/step-forward-2025/logo-caudalie.png",
    alt: "logo for caudalie",
  },
  {
    src: "/images/step-forward-2025/logo-hargreaves-lansdown.png",
    alt: "logo for lansdown",
  },
  {
    src: "/images/step-forward-2025/logo-rituals.png",
    alt: "logo for rituals",
  },
  {
    src: "/images/step-forward-2025/logo-benefit.png",
    alt: "logo for benefit",
  },
  {
    src: "/images/step-forward-2025/logo-nails.png",
    alt: "logo for nails",
  },
  {
    src: "/images/step-forward-2025/logo-boden.png",
    alt: "logo for boden",
  },
  {
    src: "/images/step-forward-2025/logo-sage.png",
    alt: "logo for sage",
  },
  {
    src: "/images/step-forward-2025/logo-sipsmith.png",
    alt: "logo for sipsmith",
  },
  {
    src: "/images/step-forward-2025/logo-gusbourne.png",
    alt: "logo for gusbourne",
  },
  {
    src: "/images/step-forward-2025/logo-ojo-de-dios.png",
    alt: "logo for ojo de dios",
  },
  {
    src: "/images/step-forward-2025/logo-appleton.png",
    alt: "logo for appleton",
  },
  {
    src: "/images/step-forward-2025/logo-pentire.png",
    alt: "logo for pentire",
  },
];

const TrustedPartnersContent: FunctionComponent = () => {
  return (
    <S.Section data-cy="SF-content-speakers">
      <S.TitleContainer>
        <H2>Trusted Partners</H2>
        <CXL>
          Together, we Step Forward to celebrate the future of female
          empowerment. Past trusted partners include...
        </CXL>
      </S.TitleContainer>
      <S.PartnersContainer>
        {partners.map((partner) => (
          <S.ImageContainer key={partner.alt}>
            <Image src={partner.src} layout="fill" objectFit="contain" />
          </S.ImageContainer>
        ))}
      </S.PartnersContainer>
      <CXL>
        Partner with us to be part of the Step Forward movement, and together
        we'll reach 60 million across impactful events, thought-provoking
        content and more, to celebrate the future of female empowerment.
      </CXL>
      <StepForwardLink
        href="mailto:partnerships@allbright.co?&subject=Step%20Forward%20Partnership%20Request%20&body=Hi,%0D%0A%0D%0AI'd%20like%20to%20book%20a%20call%20with%20a%20member%20of%20your%20team%20to%20explore%20a%20commercial%20partnership.%0DMy%20brand%20is%20[INSERT%20BRAND%20NAME],%20which%20your%20can%20find%20here%20[INSERT%20WEBSITE%20LINK].%0D%0A%0D%0AThank%20you,%0D%0A[INSERT%20NAME%20AND%20JOB%20TITLE]"
        linkText="Partner with us"
        colour={colours.charcoal}
        animationColour={colours.myPink}
      />
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  background: ${colours.white};
  padding: 10%;
  display: flex;
  flex-direction: column;
  gap: 2em;

  @media ${Device.tablet} {
    padding: 5% 10%;
  }
`;

S.TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
`;

S.PartnersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

S.ImageContainer = styled.div`
  position: relative;
  width: 50%;
  aspect-ratio: 2/1;

  @supports not (aspect-ratio: 2/1) {
    &:before {
      float: left;
      padding-top: 50%;
      content: "";
    }
    &:after {
      display: block;
      content: "";
      clear: both;
    }
  }

  @media ${Device.tablet} {
    width: 25%;
  }
`;

export default TrustedPartnersContent;
